import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";

const Spinner = () => (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "rgba(0, 0, 0, 0.7)",
      zIndex: 9999,
      color: "#ffffff",
      fontSize: "1.2rem",
    }}
  >
    <CircularProgress color="inherit" style={{ color: "#ffffff" }} />
    <div
      style={{
        marginTop: "1rem",
        animation: "fade 2s ease-in-out infinite",
      }}
    >
      Please wait...
    </div>

    {/* Inline CSS keyframes */}
    <style>
      {`
        @keyframes fade {
          0% { opacity: 1; }
          50% { opacity: 0.3; }
          100% { opacity: 1; }
        }
      `}
    </style>
  </div>
);

export default Spinner;
